import { ButtonOne, CircleButton } from "./Buttons";
import { Col, Row, Slider } from "antd";
import { useContext, useState } from "react";

import Avatar from "../assets/Avatar.png";
import { DataContext } from "../contexts/runesContext";
import Dialog from "@material-ui/core/Dialog";
import Modal from "@material-ui/core/Modal";
import QRCode from "qrcode";
import Wallet from "./Wallet";
import logo from "../assets/opis-logo.svg";
import useCollectors from "../hooks/useCollectors";
import { useMoralis } from "react-moralis";

const User = ({ nftSection }) => {
  const { user } = useMoralis();
  const ethAddress = user?.attributes?.ethAddress;
  const { contextData, setContextData } = useContext(DataContext);
  const { getRunes } = useCollectors();

  const [qrImageUrl, setQrImageUrl] = useState();

  const fetchRunes = async () => {
    const dataRunes = await getRunes();
    const { runes } = dataRunes.attributes;
    setContextData({ runes: runes });
    console.log(contextData.runes);
  };

  //Generate QR for receive to owner address
  const generateQrCode = async () => {
    if (!qrImageUrl) {
      try {
        const response = await QRCode.toDataURL(user.attributes.accounts);
        setQrImageUrl(response);
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [openQrModal, setOpenQrModal] = useState(false);
  const [onWalletModal, setOnWalletModal] = useState(false);

  return (
    <Row>
      <Col style={{ marginBottom: "8px" }}>
        <h1 style={{ color: "white", fontWeight: "700", margin: 0 }}>Regenerador</h1>
      </Col>
      <Col className="actions" style={styles.profileContainer}>
        <Col style={styles.profileContainer.topRow}>
          <h2 style={styles.profileContainer.topRow.h2}>Nivel: 0</h2>
          <CircleButton img={Avatar} />
          <h2 style={styles.profileContainer.topRow.h2}>80%</h2>
        </Col>

        <Slider
          style={styles.sliderComponent}
          defaultValue={90}
          min={0}
          max={100}
          handleStyle={styles.sliderComponent.handleStyle}
          trackStyle={styles.sliderComponent.trackStyle}
        />

        <Row>
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#78D504",
            }}
          >
            {ethAddress.slice(0, 4) +
              "..." +
              ethAddress.slice(ethAddress.length - 4, ethAddress.length)}{" "}
            Nº46
          </h1>
        </Row>

        <Row>
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "700",
              color: "#78D504",
            }}
          >
            ${contextData.runes}
            <img
              src={logo}
              alt="opis"
              style={{
                width: "48px",
                marginLeft: "20px",
              }}
            />
          </h1>
        </Row>

        <Row style={styles.buttonsContainer}>
          <ButtonOne
            text={"Recibir"}
            style={styles.buttonsContainer.button}
            onClick={() => {
              generateQrCode();
              setOpenQrModal(true);
            }}
          />
          <ButtonOne
            text={"Canjear"}
            style={styles.buttonsContainer.button}
            onClick={() =>
              window.scrollTo({ top: nftSection.current.offsetTop, behavior: "smooth" })
            }
          />
          <ButtonOne
            text={"Enviar"}
            style={styles.buttonsContainer.button}
            onClick={() => setOnWalletModal(true)}
          />
        </Row>
      </Col>

      <Dialog open={onWalletModal} onClose={() => setOnWalletModal(false)}>
        <Wallet />
      </Dialog>

      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={openQrModal}
        onClose={() => setOpenQrModal(false)}
      >
        <div className="modal-content">
          <img src={qrImageUrl} width="300px" alt="img" />
          <p>{user.attributes.accounts}</p>
        </div>
      </Modal>
    </Row>
  );
};

export default User;

const styles = {
  profileContainer: {
    display: "flex",
    flexDirection: "column",
    minHeight: "fit-content",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    borderRadius: "20px",
    alignItems: "center",
    padding: "16px",
    topRow: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      height: "fit-content",
      alignItems: "flex-end",
      h2: {
        fontSize: "20px",
        fontWeight: "600",
        margin: 0,
        color: "#78D504",
        textAlign: "center",
      },
    },
  },
  sliderComponent: {
    width: "100%",
    handleStyle: {
      backgroundColor: "#78D504",
      borderColor: "white",
    },
    trackStyle: { backgroundColor: "#78D504", height: "6px" },
  },
  buttonsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gridGap: "16px",
    button: {
      borderRadius: "8px",
      fontSize: "14",
      fontWeight: "700",
      boxShadow: "0px 8px 16px rgba(0, 171, 85, 0.24)",
    },
  },
};
